export default __webpack_public_path__ + "static/media/our-extensive-banner.6b59356b.png";